import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptors } from './utils/axiosConfig';
import { Provider } from "react-redux";
import { store } from './Components/Redux/store';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

setupAxiosInterceptors(store);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

reportWebVitals();